import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './utils/imports'
import { historyRequest } from './utils/constants'

Vue.prototype.$historyRequest = historyRequest
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
